import { render, staticRenderFns } from "./addGroupAdmin.vue?vue&type=template&id=7b045c89&scoped=true"
import script from "./addGroupAdmin.vue?vue&type=script&lang=js"
export * from "./addGroupAdmin.vue?vue&type=script&lang=js"
import style0 from "./addGroupAdmin.vue?vue&type=style&index=0&id=7b045c89&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b045c89",
  null
  
)

export default component.exports